<template>
  <div>
    <el-card style="width:100%;height: 110px" v-loading="loading">
      <div slot="header" class="card-header">
        <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>其他工时系数
      </div>
      <el-form :inline="true" :rules="otherRules" :model="dataInfo" ref="ruleForm" label-width="100px">
        <el-form-item label="巡检工时系数" prop="inshours">
          <el-input-number v-model="dataInfo.inshours" :precision="2" :step="0.1" :min="0" :max="1"
            style="width:260px"></el-input-number>
        </el-form-item>
        <el-form-item label="保养工时系数" prop="maintainhours">
          <el-input-number v-model="dataInfo.maintainhours" :precision="2" :step="0.1" :min="0" :max="1"
            style="width:260px"></el-input-number>
        </el-form-item>
        <el-form-item label="任务工时系数" prop="taskhours">
          <el-input-number v-model="dataInfo.taskhours" :precision="2" :step="0.1" :min="0" :max="1"
            style="width:260px"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()" :loading="saving">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px;height: calc(100vh - 240px)">
      <div slot="header" class="card-header">
        <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>故障工时系数
      </div>
      <div class="es-op-box">
        <el-input placeholder="请输设备类型" v-model="queryObj.keyWord" size="small" class="query"
          style="float: left;margin-bottom: 10px;" clearable @change="() => { this.queryObj.pageNum = 1; init() }">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <el-table :data="pageData.list" ref="typeTable" border stripe size="mini" height="calc(100vh - 400px)"
        style="cursor: pointer;" v-loading="loading">
        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="name" label="设备类型">
        </el-table-column>
        <el-table-column prop="manHourFactor" label="工时系数">
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
                class="el-icon-font el-icon-bianji"></i></el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="es-page-box">
        <es-pagination :data="pageData" @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadTypeList() }">
        </es-pagination>
      </div>
    </el-card>

    <!--编辑设备类型-->
    <el-dialog :visible.sync="editVisible" @closed="() => this.$refs['typeForm'].clearValidate()" width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑设备类型
      </span>
      <el-form :model="typeInfo" :rules="rules" size="mini" label-position="right" label-width="150px" ref="typeForm">
        <el-form-item prop="name" label="设备类型">
          <el-input v-model="typeInfo.name" placeholder="请输入设备类型" style="width:200px" disabled>
          </el-input>
        </el-form-item>
        <el-form-item prop="manHourFactor" label="工时系数">
          <el-input-number v-model="typeInfo.manHourFactor" :precision="2" :step="0.1" :min="0" :max="1"
            placeholder="请输入工时系数" style="width:200px" clearable>
          </el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitType()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'assettype',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      typeInfo: {},//设备类型信息
      rules: {//验证条件
        manHourFactor: [
          { required: true, message: '请输入工时系数', trigger: 'blur' },
          { type: 'number', message: '工时系数必须为数字值' }
        ]
      },
      dataInfo: {
      },
      otherRules: {
        inshours: [
          { required: true, message: '请输入巡检工时系数', trigger: 'blur' },
          { type: 'number', message: '巡检工时系数必须为数字值' }
        ],
        maintainhours: [
          { required: true, message: '请输入保养工时系数', trigger: 'blur' },
          { type: 'number', message: '保养工时系数必须为数字值' }
        ],
        taskhours: [
          { required: true, message: '请输入任务工时系数', trigger: 'blur' },
          { type: 'number', message: '任务工时系数必须为数字值' }
        ]
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadTypeList()
      this.loadOtherHours()
    },
    //从后台查询设备类型
    loadTypeList () {
      this.loading = true
      this.$ajax.get('/buss/assettype/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //从后台查询其他工时
    loadOtherHours () {
      this.loading = true
      this.$ajax.get('/buss/otherhours/otherHoursOne').then(msg => {
        this.dataInfo = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //保存其他工时
    submitForm () {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let url = "/buss/otherhours/edit";
          this.saving = true
          this.$ajax.post(url, this.dataInfo).then(msg => {
            this.saving = false
            this.loadOtherHours()
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //初始化添加设备类型
    add_init () {
      this.editVisible = true
      this.typeInfo = {
      }
    },
    //初始化编辑设备类型
    edit_init (row) {
      this.editVisible = true
      this.typeInfo = JSON.parse(JSON.stringify(row))
    },
    //保存设备类型
    submitType () {
      this.$refs["typeForm"].validate(valid => {
        if (valid) {
          let url = "/buss/assettype/add";
          if (this.typeInfo.id != null) {
            url = "/buss/assettype/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.typeInfo).then(msg => {
            this.saving = false
            this.loadTypeList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除设备类型
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["typeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/assettype/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadTypeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>

</style>
